import { useEffect } from 'react';
import { useWebsiteEditorDialogContext } from '@website-editor/context/WebsiteEditorDialogContext';
import { ACCOMMODATIONS_DIALOGS } from '../../Accommodations.dialogs';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

export const useStayDatesDialog = () => {
  const { registerDialog, dismiss, isOpen, requestShow } = useWebsiteEditorDialogContext(ACCOMMODATIONS_DIALOGS.DATES_DIALOG);

  useEffect(() => {
    registerDialog('skip');
  }, [registerDialog]);

  const handleClose = useEventCallback(() => {
    dismiss();
  });

  const requestOpen = useEventCallback(() => {
    requestShow({ force: true });
  });

  return {
    isOpen,
    onClose: handleClose,
    requestOpen,
  };
};
